import healthcareUpdate from "@custom/rtk-apis/patients/healthcareUpdate";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const healthcareUpdateSlice = createSlice({
  name: "healthcareUpdateSlice",
  initialState,
  reducers: {
    closePrescriptionModal (state:any) { state.status = ""; },
    reset: (state) => {
      state.status = "";
      state.result = null;
      state.msg = "";
      state.loading = false;
      state.error = "";
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(healthcareUpdate.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(healthcareUpdate.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = "SUCCESS";
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(healthcareUpdate.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.error = "FAILED";
        state.result = payload;
        state.loading = false;
      });
  },
});

export default healthcareUpdateSlice.reducer;
export const { closePrescriptionModal, reset } = healthcareUpdateSlice.actions;
